



















import { Component, Prop, Vue } from 'vue-property-decorator'

import { Action } from 'vuex-class'

import { ModalState, Option, OptionResourcePayload } from '@/models'

import OptionForm from './OptionForm.vue'

@Component({
  components: {
    OptionForm
  }
})
export default class CreateOptionModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState

  @Prop({ type: Number, required: true })
  readonly optionGroupId!: number

  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  data: OptionResourcePayload | null = null
  isValid = false

  @Action('menu/createOption')
  createOption!: (payload: OptionResourcePayload) => Promise<Option>

  cancel () {
    this.modalState.reset()

    this.data = null

    this.$emit('cancel')
  }

  async submit () {
    if (this.data === null || !this.isValid) {
      return
    }

    try {
      const option = await this.modalState.handle(
        this.createOption(this.data)
      )

      this.$router.push({
        name: 'OptionDetails',
        params: {
          itemGroupId: this.itemGroupId.toString(),
          optionGroupId: this.optionGroupId.toString(),
          optionId: option.id.toString()
        }
      })
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível criar nova opção.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  submitAndClose () {
    this.modalState.isActive = false
    this.submit()
  }
}
